module.exports = __webpack_public_path__ + "static/pp_icon_bullet_proof-960144ad8fb7ac524616d48519344df9.png";